import React, { useState } from 'react'
import styled from 'styled-components'
import TagsProvider from 'context/events/Tags'
import CollapseProvider from 'context/general/Collapse'
import OnSelectMenuProvider from 'context/general/OnSelectMenu'
import PreferencesProvider from 'context/user/Preferences'
import Topbar from 'components/commons/Topbar'
import Navbar from 'components/commons/Navbar'
import DashHeaderActions from 'modules/dashboard/_common/DashHeaderActions'
import Profile from 'modules/users/profile/Profile'
import EditProfile from 'modules/users/form/EditProfile'
import { UpdatePasswordDialog } from 'modules/users/profile/UpdatePasswordDialog'
import { DeleteAccountDialog } from 'modules/users/profile/DeleteAccountDialog'
import colors from 'theme/colors'
import breakpoints from 'theme/breakpoints'
import { Lock, Trash2, ChevronRight } from 'lucide-react'

export default function UserProfile() {
  const [isEditing, setIsEditing] = useState(false)
  const [openChangePassword, setOpenChangePassword] = useState(false)
  const [openDeleteAccount, setOpenDeleteAccount] = useState(false)
  const [modalSuccessPassword, setModalSuccessPassword] = useState(false)

  return (
    <OnSelectMenuProvider>
      <CollapseProvider>
        <TagsProvider>
          <PreferencesProvider>
            <PageContainer>
              <Topbar />

              {/* Executa as ações do dropdown do Topbar (sair, termos, alterar senha). */}
              <DashHeaderActions />

              <ContentArea>
                <Profile
                  isEditing={isEditing}
                  onEditClick={() => setIsEditing(prev => !prev)}
                />

                <EditSection isOpen={isEditing}>
                  <EditProfile
                    inline
                    onClose={() => setIsEditing(false)}
                  />
                </EditSection>

                <AccountSettingsCard>
                  <SettingsSectionTitle>Conta</SettingsSectionTitle>

                  <SettingsItem onClick={() => setOpenChangePassword(true)}>
                    <SettingsItemLeft>
                      <SettingsIcon><Lock size={15} color={colors.night} /></SettingsIcon>
                      <SettingsLabel>Alterar senha</SettingsLabel>
                    </SettingsItemLeft>
                    <ChevronRight size={15} color={colors.nightLight} />
                  </SettingsItem>

                  <SettingsDivider />

                  <SettingsItem danger onClick={() => setOpenDeleteAccount(true)}>
                    <SettingsItemLeft>
                      <SettingsIcon><Trash2 size={15} color={colors.danger} /></SettingsIcon>
                      <SettingsLabel danger>Excluir conta</SettingsLabel>
                    </SettingsItemLeft>
                    <ChevronRight size={15} color={colors.danger} />
                  </SettingsItem>
                </AccountSettingsCard>
              </ContentArea>

              {openChangePassword && (
                <UpdatePasswordDialog
                  open={openChangePassword}
                  setOpen={setOpenChangePassword}
                  setModalSucessPassword={setModalSuccessPassword}
                />
              )}

              {openDeleteAccount && (
                <DeleteAccountDialog
                  open={openDeleteAccount}
                  setOpen={setOpenDeleteAccount}
                />
              )}

              <Navbar />
            </PageContainer>
          </PreferencesProvider>
        </TagsProvider>
      </CollapseProvider>
    </OnSelectMenuProvider>
  )
}

const PageContainer = styled.div`
  min-height: 100vh;
  background: ${colors.neutralBackground};
  display: flex;
  flex-direction: column;
`

const ContentArea = styled.div`
  padding-bottom: 80px;
`

const EditSection = styled.div`
  overflow: hidden;
  max-height: ${({ isOpen }) => isOpen ? '3000px' : '0'};
  transition: max-height ${({ isOpen }) => isOpen ? '0.5s ease' : '0.3s ease'};
`

const AccountSettingsCard = styled.div`
  background: ${colors.neutralLight};
  box-shadow: 0 1px 4px rgba(0,0,0,0.08), 0 4px 20px rgba(0,0,0,0.04);
  margin-top: 8px;
  padding: 16px 20px;

  @media screen and (min-width: ${breakpoints.sm}) {
    max-width: 640px;
    margin: 8px auto 0;
    border-radius: 14px;
  }
`

const SettingsSectionTitle = styled.p`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${colors.nightLight};
  margin: 0 0 12px;
`

const SettingsItem = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 4px;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 8px;
  transition: background 0.15s ease;

  &:hover {
    background: ${({ danger }) => danger ? '#fff1f2' : colors.neutralBackground};
  }
`

const SettingsItemLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const SettingsIcon = styled.span`
  display: flex;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: ${colors.neutralBackground};
  justify-content: center;
  flex-shrink: 0;
`

const SettingsLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${({ danger }) => danger ? colors.danger : colors.nightDark};
`

const SettingsDivider = styled.div`
  height: 1px;
  background: ${colors.neutralDark};
  margin: 2px 0;
`
